import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import TutorialCard from "../../Components/TutorialCard";
import Button from '../../Components/Button'
import Navbar from '../../Components/Navbar'
export default class Tutorial extends Component {
    render() {
        let titles = ['Easy', 'Medium', 'Hard'];
        let paragraphs = [
            "Find numbers in the Grid one-by-one sequentially starting from 1. In this Level once you click a number it will disappear from the grid. If you miss the sequence the game will be over.",
            "In this Level the rules are same but with some changes. Every time you click a number the number will not be disappear and the whole board will be suffled.",
            "In this Level also after clicking a number, the number will not disappear  and the board will be suffled.  Here in this level You will play the game with optical Illusions"
        ];
        return (
            <>
                <header>
                    <Navbar/>
                </header>
                <main className="main">
                    <TutorialCard title={titles[0]} content={paragraphs[0]}></TutorialCard>
                    <TutorialCard title={titles[1]} content={paragraphs[1]}></TutorialCard>
                    <TutorialCard title={titles[2]} content={paragraphs[2]}></TutorialCard>
                    <Link to="/schulteHome"><Button btn="other-button" number="Back"></Button></Link>
                </main>
            </>
            
        )
    }
}
